import { CONTACT_SESSIONS } from "../../../graphql/queries.js";
import { resolveComponent, createBlock, openBlock, withCtx, createVNode, createElementVNode, createTextVNode, toDisplayString, createElementBlock, createCommentVNode, Fragment, renderList } from "vue";
import _export_sfc from "../../../_virtual/_plugin-vue_export-helper.js";
import { VCard, VCardSubtitle, VCardText, VCardActions } from "vuetify/components/VCard";
import { VDialog } from "vuetify/components/VDialog";
import { VDivider } from "vuetify/components/VDivider";
import { VRow, VCol, VSpacer } from "vuetify/components/VGrid";
import { VIcon } from "vuetify/components/VIcon";
const _sfc_main = {
  components: { EmptyData: () => import("../../Base/EmptyData.vue.js") },
  props: {
    item: {
      type: Object
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      sessions: [],
      page: 0,
      pageSize: 15,
      infiniteId: +/* @__PURE__ */ new Date(),
      infiniteState: null,
      infinitInitialized: false,
      dataLoaded: false
    };
  },
  computed: {
    show: {
      get() {
        return this.visible;
      },
      set(value) {
        this.$emit("update:visible", value);
      }
    }
  },
  methods: {
    reload() {
      this.sessions = [];
      this.infinitInitialized = false;
      this.infiniteId++;
    },
    formatDate(value) {
      return this.$moment(value).local().format("lll");
    },
    infiniteHandler(state) {
      this.dataLoaded = false;
      this.infiniteState = state;
      if (!this.infinitInitialized) {
        this.page = 0;
        this.infinitInitialized = true;
      } else {
        this.page++;
      }
    }
  },
  apollo: {
    contactsData: {
      query() {
        return CONTACT_SESSIONS;
      },
      variables() {
        return {
          take: this.pageSize,
          skip: this.pageSize * this.page,
          order: {
            start: "DESC"
          },
          where: {
            contactId: {
              eq: this.item.id
            }
          }
        };
      },
      skip() {
        return !this.infinitInitialized;
      },
      update: (data) => data.items,
      result({ data, loading }) {
        var _a;
        if (!loading && data) {
          this.dataLoaded = true;
          if ((_a = data.items) == null ? void 0 : _a.items) {
            this.sessions.push(...data.items.items);
          }
          if (this.infiniteState) {
            const hasNextPage = data.items.pageInfo.hasNextPage;
            if (hasNextPage) {
              this.infiniteState.loaded();
            } else {
              this.infiniteState.complete();
            }
          }
        }
      }
    }
  }
};
const _hoisted_1 = { class: "d-flex justify-space-between flex-nowrap align-center pa-4" };
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_b_btn = resolveComponent("b-btn");
  const _component_empty_data = resolveComponent("empty-data");
  const _component_infinite_loading = resolveComponent("infinite-loading");
  return openBlock(), createBlock(VDialog, {
    modelValue: $options.show,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => $options.show = $event),
    "max-width": "750",
    scrollable: "",
    fullscreen: _ctx.$vuetify.display.xsOnly
  }, {
    default: withCtx(() => [
      createVNode(VCard, {
        outlined: "",
        class: "overflow-hidden",
        height: "90vh"
      }, {
        default: withCtx(() => [
          createElementVNode("div", _hoisted_1, [
            createTextVNode(toDisplayString($props.item.name) + " ", 1),
            createVNode(_component_b_btn, {
              preset: "closeMini",
              onClick: _cache[0] || (_cache[0] = ($event) => $options.show = false)
            })
          ]),
          createVNode(VDivider),
          createVNode(VCardSubtitle, { class: "white--text py-2 px-3" }, {
            default: withCtx(() => [
              createVNode(VRow, {
                "no-gutters": "",
                dense: ""
              }, {
                default: withCtx(() => [
                  createVNode(VCol, { cols: "1" }, {
                    default: withCtx(() => [
                      createVNode(VIcon, {
                        onClick: $options.reload,
                        icon: "mdi-reload"
                      }, null, 8, ["onClick"])
                    ]),
                    _: 1
                  }),
                  createVNode(VCol, { cols: "4" }, {
                    default: withCtx(() => [
                      createTextVNode(toDisplayString(_ctx.$t("components.users.actions.sessions.start")), 1)
                    ]),
                    _: 1
                  }),
                  createVNode(VCol, { cols: "4" }, {
                    default: withCtx(() => [
                      createTextVNode(toDisplayString(_ctx.$t("components.users.actions.sessions.end")), 1)
                    ]),
                    _: 1
                  }),
                  createVNode(VCol, { cols: "3" }, {
                    default: withCtx(() => [
                      createTextVNode(toDisplayString(_ctx.$t("qrtz_management.duration")), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          createVNode(VDivider),
          createVNode(VCardText, {
            class: "px-3",
            style: { "overflow-x": "hidden" }
          }, {
            default: withCtx(() => [
              (openBlock(true), createElementBlock(Fragment, null, renderList($data.sessions, (session) => {
                return openBlock(), createBlock(VRow, {
                  key: session.id,
                  "no-gutters": "",
                  dense: "",
                  class: "align-center pt-1"
                }, {
                  default: withCtx(() => [
                    createVNode(VCol, { cols: "1" }, {
                      default: withCtx(() => [
                        createVNode(VIcon, {
                          color: session.isActive ? "green" : "red"
                        }, {
                          default: withCtx(() => [
                            createTextVNode(toDisplayString(session.isActive ? "mdi-lock-open-variant" : "mdi-lock"), 1)
                          ]),
                          _: 2
                        }, 1032, ["color"])
                      ]),
                      _: 2
                    }, 1024),
                    createVNode(VCol, {
                      cols: "4",
                      class: "pr-1"
                    }, {
                      default: withCtx(() => [
                        createTextVNode(toDisplayString($options.formatDate(session.start)), 1)
                      ]),
                      _: 2
                    }, 1024),
                    createVNode(VCol, {
                      cols: "4",
                      class: "pl-1"
                    }, {
                      default: withCtx(() => [
                        createTextVNode(toDisplayString(session.isActive ? " - " : $options.formatDate(session.end)), 1)
                      ]),
                      _: 2
                    }, 1024),
                    createVNode(VCol, {
                      cols: "3",
                      class: "pl-1"
                    }, {
                      default: withCtx(() => [
                        createTextVNode(toDisplayString(session.isActive ? "-" : _ctx.$moment.duration(_ctx.$moment(session.start).diff(_ctx.$moment(session.end))).humanize()), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024);
              }), 128)),
              $data.dataLoaded && !$data.sessions.length ? (openBlock(), createBlock(_component_empty_data, {
                key: 0,
                subtitle: _ctx.$t("pages.public.index.no_data"),
                class: "mt-4"
              }, null, 8, ["subtitle"])) : createCommentVNode("", true),
              createVNode(_component_infinite_loading, {
                identifier: $data.infiniteId,
                onInfinite: $options.infiniteHandler
              }, {
                "no-results": withCtx(() => _cache[3] || (_cache[3] = [
                  createElementVNode("div", null, null, -1)
                ])),
                "no-more": withCtx(() => _cache[4] || (_cache[4] = [
                  createElementVNode("div", null, null, -1)
                ])),
                _: 1
              }, 8, ["identifier", "onInfinite"])
            ]),
            _: 1
          }),
          createVNode(VCardActions, { class: "px-6 pb-4 pt-3" }, {
            default: withCtx(() => [
              createVNode(VSpacer),
              createVNode(_component_b_btn, {
                preset: "close",
                onClick: _cache[1] || (_cache[1] = ($event) => $options.show = false)
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue", "fullscreen"]);
}
const UserSessions = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);
export {
  UserSessions as default
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
